/** Pictures and years for the roadmap milestones, shared by the desktop and the mobile designs. */

/** One picture per milestone, in roadmap order, each one about what that step was. */
export const MILESTONE_ART = [
  '/redesign2/roadmap/00.webp', // 2012: puppy Zeus born in a basket above a Balkan village
  '/redesign2/roadmap/01.webp', // 2022: ndhaus's original drawing of Zeus
  '/redesign2/roadmap/02.webp', // May 2025: Zeus presses launch, the coin takes off
  '/redesign2/roadmap/03.webp', // June 2025: Pepe and Brett carry the original artwork home
  '/redesign2/roadmap/04.webp', // October 2025: the gang votes, Zeus raises a paw
  '/redesign2/roadmap/05.webp', // November 2025: the bridge to another island, a coin tip
  '/redesign2/roadmap/06.webp', // December 2025: the treasury team in the vault
  '/redesign2/roadmap/07.webp', // January 2026: everyone builds with AI on the porch
  '/redesign2/roadmap/08.webp', // Q1 2026: the gang builds its own workshop
  '/redesign2/roadmap/09.webp', // Q2 2026: coins grow, Zeus guards the floor
  '/redesign2/roadmap/10.webp', // Q3 2026: Zeus at the black hole, our stablecoin
];
export const yearOf = (stop: { lines: string[] }) => (stop.lines.join(' ').match(/\b20\d\d\b/) || [''])[0];

